import Vue from 'vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

Vue.component('vue-perfect-scrollbar', VuePerfectScrollbar)
